export const getSanityImages = (partnerOverride?: string) => {
  switch (partnerOverride) {
    case 'castorama':
      return {
        housePin: null,
        solarPanel: null,
        houseWithPanels: null,
      };
    default:
      return {
        housePin:
          'https://cdn.sanity.io/images/nmid0lyc/production/02debdb8645ebdd4bd228cc4fbe15075df6c5fd1-454x300.svg?h=800&q=90&auto=format',
        solarPanel:
          'https://cdn.sanity.io/images/nmid0lyc/production/fa313879df06c20092fc44afbf2e914b6a64424f-454x300.svg?h=800&q=90&auto=format',
        houseWithPanels:
          'https://cdn.sanity.io/images/nmid0lyc/production/a76b7783c5ef23cda6d1ff83ac557b9248090e35-454x300.svg?h=800&q=90&auto=format',
      };
  }
};
